import * as THREE from "three";
import { defineModel, type Part } from "../../lib";

// Modern kit ground tile: a 1x1 m slab exactly 0.06 thick (top at y = 0.06),
// centred on the origin, seating seamlessly against every other ground tile.
const SIDEWALK = "#b5b0a6";
const JOINT = "#9d9689";

export const sidewalkTile = defineModel({
  id: "sidewalk-tile",
  batchId: "modern",
  name: "Sidewalk tile",
  tags: ["modern", "outdoor", "ground", "street", "sidewalk", "pavement"],
  summary: "A concrete sidewalk tile with paving-slab joint lines.",
  description:
    "A one-tile concrete sidewalk of the Modern Living kit: a 1x1 m slab " +
    "(0.06 m thick) with two flush joint grooves each way, reading as a 3x3 " +
    "grid of paving slabs from above. Tiles seamlessly with every other " +
    "ground piece.",
  tiles: { w: 1, h: 1 },
  footprint: 0.75,
  parts(): Part[] {
    const third = 1 / 6; // joint offset: divides the tile into thirds
    return [
      { geometry: new THREE.BoxGeometry(1.0, 0.06, 1.0), color: SIDEWALK, position: [0, 0.03, 0] },
      // Two joint grooves along Z (thin in X)...
      {
        geometry: new THREE.BoxGeometry(0.025, 0.012, 1.0),
        color: JOINT,
        position: [-third, 0.06, 0],
      },
      {
        geometry: new THREE.BoxGeometry(0.025, 0.012, 1.0),
        color: JOINT,
        position: [third, 0.06, 0],
      },
      // ...and two along X (thin in Z), reading as paving slabs.
      {
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.025),
        color: JOINT,
        position: [0, 0.06, -third],
      },
      {
        geometry: new THREE.BoxGeometry(1.0, 0.012, 0.025),
        color: JOINT,
        position: [0, 0.06, third],
      },
    ];
  },
  animations: [],
});
